import React, { useEffect, useState } from "react";
// ANT DESIGN COMPONENTS
import { Drawer, Button } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import { updateOpenDrawerChannel } from "../../../redux/channels/channelSlice";
// COMPONENTS
import DrawerChannelInformation from "../../components/drawer/DrawerChannelInformation";
import DrawerServerInformation from "../../components/drawer/DrawerServerInformation";

function ChannelsDrawer() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const dispatch = useDispatch();
  const [t] = useTranslation("global");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const [data, setData] = useState<any>({});

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { channel, openDrawerChannel } = useSelector((state: any) => state.channel);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onClickClose = () => {
    dispatch(updateOpenDrawerChannel(false));
  };

  // ************************************************* */
  // USE EFFECT ************************************** */
  useEffect(() => {
    if (openDrawerChannel) {
      if (channel) {
        setData(channel);
      }
    }
  }, [openDrawerChannel]);

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <Drawer
      width={550}
      placement="right"
      onClose={onClickClose}
      closable={false}
      open={openDrawerChannel}
    >
      {data && (
        <div>
          {/** ************************************************* */}
          {/** CHANNEL INFORMATION */}
          <DrawerChannelInformation data={channel || {}} />
          <br />
          {/** ************************************************* */}
          {/** SERVER INFORMATION */}
          <DrawerServerInformation data={channel && channel.server ? channel.server : {}} />
          <br />
        </div>
      )}
      {/** ************************************************* */}
      {/** CLOSE AND SUBMIT BUTTONS */}
      <div className="mt-4 generalStyles__width100">
        <div>
          <Button type="default" onClick={onClickClose} className="buttonStyle__5">
            {t("organizationManagement.close")}
          </Button>
        </div>
      </div>
    </Drawer>
  );
}

export default ChannelsDrawer;
